'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var varint$1 = require('../vendor/varint.js');

var decode = function decode(data) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var code = varint$1.decode(data, offset);
  return [code, varint$1.decode.bytes];
};

var encodeTo = function encodeTo(_int, target) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  varint$1.encode(_int, target, offset);
  return target;
};

var encodingLength = function encodingLength(_int2) {
  return varint$1.encodingLength(_int2);
};

exports.decode = decode;
exports.encodeTo = encodeTo;
exports.encodingLength = encodingLength;